import { useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';

const Header = () => {
  const location = useLocation();

  const getPageTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'Daddy Time';
      case '/profile':
        return 'Profile';
      case '/auth/verify':
        return 'Sign In';
      default:
        return 'Daddy Time';
    }
  };

  const getSubtitle = (): string => {
    const tagline = 'Your Daddy Dom, Whenever You Need';
    switch (location.pathname) {
      case '/':
        return tagline;
      case '/profile':
        return 'Your account & settings';
      case '/auth/verify':
        return 'Complete your sign-in';
      default:
        return tagline;
    }
  };

  return (
    <header
      className="border-b border-accent-pink sticky top-0 z-50"
      style={{ background: 'linear-gradient(135deg, #fef5f7 0%, #fbcfe8 100%)' }}
    >
      <div className="max-w-lg mx-auto px-5 py-4 relative">
        {/* Logo Icon */}
        <div className="absolute top-4 left-5 flex items-center justify-center w-[52px] h-[52px] bg-gradient-to-br from-primary-pink to-pastel-purple rounded-xl shadow-sm">
          <Heart className="w-6 h-6 text-text-dark" fill="currentColor" />
        </div>

        {/* Text Content with Left Padding for Logo */}
        <div className="pl-[68px]">
          <h1 className="text-2xl font-bold text-text-dark leading-tight">
            {getPageTitle()}
          </h1>
          <p className="text-sm text-text-medium mt-0.5">{getSubtitle()}</p>
        </div>
      </div>
    </header>
  );
};

export default Header;
